// src/components/ContentViews/ResultItem.js
import React from 'react';

const ResultItem = ({ title, description, image, onSelect }) => {
  return (
    <div
      className="flex items-center space-x-4 p-4 border rounded hover:shadow-md cursor-pointer"
      onClick={onSelect}
    >
      {image && (
        <img
          src={image}
          alt={title}
          className="w-16 h-16 object-cover rounded"
        />
      )}
      <div>
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-sm text-gray-600">{description}</p>
      </div>
    </div>
  );
};

export default ResultItem;
